<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header border-0 justify-content-between">
        <h5 class="card-title font-bold">جزئیات آزمایش</h5>
        <b-button variant="primary" v-b-modal.edit-experiment-detail>
          <i class="fe fe-edit"></i>
        </b-button>
      </div>
      <div class="card-body">
        <div v-if="item && !$root.isEmptyObject(item)" class="row">
          <div class="d-flex align-items-center col-4 mb-4">
            <h6 class="font-weight-bold mb-0">شناسه :</h6>
            <p class="mb-0 mr-2">{{ item.user_id }}</p>
          </div>
          <template v-if="item.user">
            <div class="d-flex align-items-center col-4 mb-4">
              <h6 class="font-weight-bold mb-0">نام کاربر :</h6>
              <p class="mb-0 mr-2">
                {{ item.user.first_name + " " + item.user.last_name }}
              </p>
            </div>
            <div class="d-flex align-items-center col-4 mb-4">
              <h6 class="font-weight-bold mb-0">موبایل :</h6>
              <p class="mb-0 mr-2">
                {{ item.user.mobile }}
              </p>
            </div>
          </template>
          <div class="d-flex align-items-center col-4 mb-4">
            <h6 class="font-weight-bold mb-0">توضیحات :</h6>
            <p class="mb-0 mr-2">
              {{ item.description ? item.description : "ندارد" }}
            </p>
          </div>
          <div class="d-flex align-items-center col-4 mb-4">
            <h6 class="font-weight-bold mb-0">توضیحات ادمین :</h6>
            <p class="mb-0 mr-2">
              {{ item.admin_description ? item.admin_description : "ندارد" }}
            </p>
          </div>
          <div class="d-flex align-items-center col-4 mb-4">
            <h6 class="font-weight-bold mb-0">آدرس :</h6>
            <p class="mb-0 mr-2">
              {{ item.address ? item.address.address : "ندارد" }}
            </p>
          </div>
          <div class="d-flex align-items-center col-4 mb-4">
            <h6 class="font-weight-bold mb-0">تاریخ دریافت :</h6>
            <p class="mb-0 mr-2">{{ item.receive_datetime | persianDate }}</p>
          </div>
          <div class="d-flex align-items-center col-4">
            <h6 class="font-weight-bold mb-0">وضعیت :</h6>
            <p
              :style="{ backgroundColor: getStatusColor(item.status) }"
              class="badge badge-info mb-0 mr-2"
            >
              {{ getStatus(item.status) }}
            </p>
          </div>
          <div
            v-if="item && item.serial && !$root.isEmptyObject(item.serial)"
            class="w-100 mt-5"
          >
            <BButton
              class="w-100 serialInfoToggle"
              v-b-toggle.serial-info-collapse
              variant="primary"
            >
              <span class="font-weight-bold">اطلاعات سریال</span>
            </BButton>
            <BCollapse visible id="serial-info-collapse">
              <div
                class="row align-items-center serialInfoCollapse border border-primary mx-auto pt-4"
              >
                <div class="d-flex align-items-center col-4 mb-4">
                  <h6 class="font-weight-bold mb-0">شناسه :</h6>
                  <p class="mb-0 mr-2">
                    {{ item.serial.id }}
                  </p>
                </div>
                <div class="d-flex align-items-center col-4 mb-4">
                  <h6 class="font-weight-bold mb-0">شناسه محصول :</h6>
                  <p class="mb-0 mr-2">
                    {{ item.serial.product_id }}
                  </p>
                </div>
                <div class="d-flex align-items-center col-4 mb-4">
                  <h6 class="font-weight-bold mb-0">شماره سریال :</h6>
                  <p class="mb-0 mr-2">
                    {{ item.serial.serial }}
                  </p>
                </div>
                <div class="d-flex align-items-center col-4 mb-4">
                  <h6 class="font-weight-bold mb-0">وضعیت :</h6>
                  <p class="mb-0 mr-2">
                    <span
                      v-if="item.serial.status === 'damaged'"
                      class="badge badge-danger status"
                      >معیوب</span
                    >
                    <span
                      v-else-if="item.serial.status === 'available'"
                      class="badge badge-success status"
                      >موجود</span
                    >
                    <span
                      v-else-if="item.serial.status === 'draft'"
                      class="badge badge-info status"
                      >پیش نویس</span
                    >
                  </p>
                </div>
              </div>
            </BCollapse>
          </div>
          <div class="w-100 mt-5">
            <BButton
              class="w-100 d-flex align-items-center justify-content-between serialInfoToggle"
              variant="primary"
            >
              <span class="font-weight-bold">نتیجه آزمایش</span>
              <span
                class="btn btn-light py-0 px-2"
                v-b-modal.edit-experiment-result
              >
                <i class="fe fe-edit"></i>
              </span>
            </BButton>
            <BCollapse visible id="experimant-result-collapse">
              <div
                class="row align-items-center serialInfoCollapse border border-primary mx-auto pt-4"
              >
                <div class="d-flex align-items-center col-4 mb-4">
                  <h6 class="font-weight-bold mb-0">انجام شده در تاریخ :</h6>
                  <p class="mb-0 mr-2">
                    {{ item.done_at | persianDate }}
                  </p>
                </div>
                <div class="d-flex align-items-center col-4 mb-4">
                  <h6 class="font-weight-bold mb-0">نتیجه :</h6>
                  <p class="mb-0 mr-2">
                    {{ item.result ? "دارد" : "ندارد" }}
                  </p>
                </div>
                <div class="d-flex align-items-center col-4 mb-4">
                  <h6 class="font-weight-bold mb-0">فایل های ضمیمه :</h6>
                  <p class="mb-0 mr-2">
                    {{
                      item.media_showcase.files
                        ? item.media_showcase.files.length
                        : ""
                    }}
                  </p>
                </div>
                <div class="d-flex align-items-center col-6 mb-4">
                  <h6 class="font-weight-bold mb-0">توضیحات :</h6>
                  <p class="mb-0 mr-2">
                    {{ item.result_description }}
                  </p>
                </div>
              </div>
            </BCollapse>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      size="md"
      centered
      :hideFooter="true"
      title="ویرایش آزمایش"
      id="edit-experiment-detail"
    >
      <BForm @submit.prevent="submitExperimentEdit">
        <BFormGroup label="توضیحات">
          <BFormTextarea
            v-model="editForm.description"
            placeholder="توضیحات..."
            rows="3"
          />
        </BFormGroup>
        <BFormGroup label="توضیحات ادمین">
          <BFormTextarea
            v-model="editForm.admin_description"
            placeholder="توضیحات ادمین..."
            rows="3"
          />
        </BFormGroup>
        <div class="row">
          <b-form-group class="col-5" label="تاریخ دریافت">
            <date-picker
              type="datetime"
              v-model="editForm.receive_datetime"
              format="YYYY-MM-DD HH:mm:ss"
              display-format="jYYYY/jMM/jDD HH:mm"
              color="#3366ff"
            />
          </b-form-group>
          <BFormGroup class="col-5" label="وضعیت">
            <BFormSelect v-model="editForm.status" :options="statusOptions" />
          </BFormGroup>
        </div>
        <b-button :disabled="disabled" type="submit" variant="success"
          >ثبت</b-button
        >
      </BForm>
    </b-modal>
    <b-modal
      size="lg"
      centered
      :hideFooter="true"
      title="ویرایش نتیجه آزمایش"
      id="edit-experiment-result"
    >
      <BForm @submit.prevent="submitExperimentResult">
        <div class="row">
          <BFormGroup class="col-7" label="توضیحات">
            <BFormTextarea
              v-model="resultForm.result_description"
              placeholder="توضیحات..."
              rows="3"
            />
          </BFormGroup>
          <div class="d-flex flex-column align-items-start col-4">
            <b-form-group label="تاریخ انجام :">
              <date-picker
                type="datetime"
                v-model="resultForm.done_at"
                format="YYYY-MM-DD HH:mm:ss"
                display-format="jYYYY/jMM/jDD HH:mm"
                color="#3366ff"
              />
            </b-form-group>
            <b-form-group>
              <BFormCheckbox
                style="direction: ltr;"
                id="checkbox-1"
                v-model="resultForm.result"
                :value="1"
                :unchecked-value="0"
              >
                : نتیجه
              </BFormCheckbox>
            </b-form-group>
          </div>
        </div>
        <div v-if="item && item.media_showcase" class="w-100">
          <ExperimentFiles
            @deleted-iles-id="deletedFilesId"
            @new-files="newFiles"
            :files="item.media_showcase.files"
          />
        </div>
        <b-button :disabled="disabled" type="submit" variant="success"
          >ثبت</b-button
        >
      </BForm>
    </b-modal>
  </main>
</template>

<script>
import ExperimentShowEditImpl from "@@/core/pages/experiment/ExperimentEdit/ExperimentShowEditImpl.js";
export default {
  extends: ExperimentShowEditImpl,
};
</script>
<style>
.serialInfoToggle {
  border-radius: 5px 5px 0 0;
}
.serialInfoCollapse {
  width: 100%;
  border-radius: 0 0 5px 5px;
}
</style>
